/* eslint-disable @typescript-eslint/no-explicit-any */
import {CONSTANTS} from '../constants/constants';
import {HttpMethod, httpClient} from './httpClient';

export const getSubscriberStatus = (subscriberId: string): Promise<any> => {
  return httpClient(`/notifications/notification/isuseractive?subscriberId=${subscriberId}`, HttpMethod.Get, null, CONSTANTS.SERVICE_TYPES.NOTIFICATIONS);
};